import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

export default function PromptDialog({ open, onClose, onConfirm, children , Title="Confirmation",closeButtonText="Cancel" }) {
  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(true);
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogTitle>{Title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
       
        <Button onClick={handleClose} sx={{minHeight: "39px", minWidth:"90px"}} variant="outlined">
          {closeButtonText}
        </Button>
        
        <Button onClick={handleConfirm} sx={{minHeight: "39px", minWidth:"90px"}} className="shadow-none " variant="contained" color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
